/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as VerifyEmailRouteImport } from "./routes/verify-email"
import { Route as TermsRouteImport } from "./routes/terms"
import { Route as SignupRouteImport } from "./routes/signup"
import { Route as ResetRouteImport } from "./routes/reset"
import { Route as PrivacyRouteImport } from "./routes/privacy"
import { Route as PricingRouteImport } from "./routes/pricing"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as ForgotRouteImport } from "./routes/forgot"
import { Route as AppRouteImport } from "./routes/_app"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as TeamAcceptRouteImport } from "./routes/team.accept"
import { Route as ShareAlbumRouteImport } from "./routes/share.album"
import { Route as AppWelcomeRouteImport } from "./routes/_app.welcome"
import { Route as AppUsageRouteImport } from "./routes/_app.usage"
import { Route as AppTriggersRouteImport } from "./routes/_app.triggers"
import { Route as AppTeamRouteImport } from "./routes/_app.team"
import { Route as AppSettingsRouteImport } from "./routes/_app.settings"
import { Route as AppSearchRouteImport } from "./routes/_app.search"
import { Route as AppSchedulesRouteImport } from "./routes/_app.schedules"
import { Route as AppPromptsRouteImport } from "./routes/_app.prompts"
import { Route as AppProjectsRouteImport } from "./routes/_app.projects"
import { Route as AppMemoryRouteImport } from "./routes/_app.memory"
import { Route as AppMediaRouteImport } from "./routes/_app.media"
import { Route as AppKnowledgeRouteImport } from "./routes/_app.knowledge"
import { Route as AppConversationsRouteImport } from "./routes/_app.conversations"
import { Route as AppConnectorsRouteImport } from "./routes/_app.connectors"
import { Route as AppChatRouteImport } from "./routes/_app.chat"
import { Route as AppBrainRouteImport } from "./routes/_app.brain"
import { Route as AppBillingRouteImport } from "./routes/_app.billing"
import { Route as AppAutonomyRouteImport } from "./routes/_app.autonomy"
import { Route as AppAccountRouteImport } from "./routes/_app.account"

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: "/verify-email",
  path: "/verify-email",
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: "/terms",
  path: "/terms",
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: "/signup",
  path: "/signup",
  getParentRoute: () => rootRouteImport,
} as any)
const ResetRoute = ResetRouteImport.update({
  id: "/reset",
  path: "/reset",
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: "/pricing",
  path: "/pricing",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotRoute = ForgotRouteImport.update({
  id: "/forgot",
  path: "/forgot",
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const TeamAcceptRoute = TeamAcceptRouteImport.update({
  id: "/team/accept",
  path: "/team/accept",
  getParentRoute: () => rootRouteImport,
} as any)
const ShareAlbumRoute = ShareAlbumRouteImport.update({
  id: "/share/album",
  path: "/share/album",
  getParentRoute: () => rootRouteImport,
} as any)
const AppWelcomeRoute = AppWelcomeRouteImport.update({
  id: "/welcome",
  path: "/welcome",
  getParentRoute: () => AppRoute,
} as any)
const AppUsageRoute = AppUsageRouteImport.update({
  id: "/usage",
  path: "/usage",
  getParentRoute: () => AppRoute,
} as any)
const AppTriggersRoute = AppTriggersRouteImport.update({
  id: "/triggers",
  path: "/triggers",
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: "/team",
  path: "/team",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: "/search",
  path: "/search",
  getParentRoute: () => AppRoute,
} as any)
const AppSchedulesRoute = AppSchedulesRouteImport.update({
  id: "/schedules",
  path: "/schedules",
  getParentRoute: () => AppRoute,
} as any)
const AppPromptsRoute = AppPromptsRouteImport.update({
  id: "/prompts",
  path: "/prompts",
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsRoute = AppProjectsRouteImport.update({
  id: "/projects",
  path: "/projects",
  getParentRoute: () => AppRoute,
} as any)
const AppMemoryRoute = AppMemoryRouteImport.update({
  id: "/memory",
  path: "/memory",
  getParentRoute: () => AppRoute,
} as any)
const AppMediaRoute = AppMediaRouteImport.update({
  id: "/media",
  path: "/media",
  getParentRoute: () => AppRoute,
} as any)
const AppKnowledgeRoute = AppKnowledgeRouteImport.update({
  id: "/knowledge",
  path: "/knowledge",
  getParentRoute: () => AppRoute,
} as any)
const AppConversationsRoute = AppConversationsRouteImport.update({
  id: "/conversations",
  path: "/conversations",
  getParentRoute: () => AppRoute,
} as any)
const AppConnectorsRoute = AppConnectorsRouteImport.update({
  id: "/connectors",
  path: "/connectors",
  getParentRoute: () => AppRoute,
} as any)
const AppChatRoute = AppChatRouteImport.update({
  id: "/chat",
  path: "/chat",
  getParentRoute: () => AppRoute,
} as any)
const AppBrainRoute = AppBrainRouteImport.update({
  id: "/brain",
  path: "/brain",
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: "/billing",
  path: "/billing",
  getParentRoute: () => AppRoute,
} as any)
const AppAutonomyRoute = AppAutonomyRouteImport.update({
  id: "/autonomy",
  path: "/autonomy",
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/forgot": typeof ForgotRoute
  "/login": typeof LoginRoute
  "/pricing": typeof PricingRoute
  "/privacy": typeof PrivacyRoute
  "/reset": typeof ResetRoute
  "/signup": typeof SignupRoute
  "/terms": typeof TermsRoute
  "/verify-email": typeof VerifyEmailRoute
  "/account": typeof AppAccountRoute
  "/autonomy": typeof AppAutonomyRoute
  "/billing": typeof AppBillingRoute
  "/brain": typeof AppBrainRoute
  "/chat": typeof AppChatRoute
  "/connectors": typeof AppConnectorsRoute
  "/conversations": typeof AppConversationsRoute
  "/knowledge": typeof AppKnowledgeRoute
  "/media": typeof AppMediaRoute
  "/memory": typeof AppMemoryRoute
  "/projects": typeof AppProjectsRoute
  "/prompts": typeof AppPromptsRoute
  "/schedules": typeof AppSchedulesRoute
  "/search": typeof AppSearchRoute
  "/settings": typeof AppSettingsRoute
  "/team": typeof AppTeamRoute
  "/triggers": typeof AppTriggersRoute
  "/usage": typeof AppUsageRoute
  "/welcome": typeof AppWelcomeRoute
  "/share/album": typeof ShareAlbumRoute
  "/team/accept": typeof TeamAcceptRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/forgot": typeof ForgotRoute
  "/login": typeof LoginRoute
  "/pricing": typeof PricingRoute
  "/privacy": typeof PrivacyRoute
  "/reset": typeof ResetRoute
  "/signup": typeof SignupRoute
  "/terms": typeof TermsRoute
  "/verify-email": typeof VerifyEmailRoute
  "/account": typeof AppAccountRoute
  "/autonomy": typeof AppAutonomyRoute
  "/billing": typeof AppBillingRoute
  "/brain": typeof AppBrainRoute
  "/chat": typeof AppChatRoute
  "/connectors": typeof AppConnectorsRoute
  "/conversations": typeof AppConversationsRoute
  "/knowledge": typeof AppKnowledgeRoute
  "/media": typeof AppMediaRoute
  "/memory": typeof AppMemoryRoute
  "/projects": typeof AppProjectsRoute
  "/prompts": typeof AppPromptsRoute
  "/schedules": typeof AppSchedulesRoute
  "/search": typeof AppSearchRoute
  "/settings": typeof AppSettingsRoute
  "/team": typeof AppTeamRoute
  "/triggers": typeof AppTriggersRoute
  "/usage": typeof AppUsageRoute
  "/welcome": typeof AppWelcomeRoute
  "/share/album": typeof ShareAlbumRoute
  "/team/accept": typeof TeamAcceptRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/_app": typeof AppRouteWithChildren
  "/forgot": typeof ForgotRoute
  "/login": typeof LoginRoute
  "/pricing": typeof PricingRoute
  "/privacy": typeof PrivacyRoute
  "/reset": typeof ResetRoute
  "/signup": typeof SignupRoute
  "/terms": typeof TermsRoute
  "/verify-email": typeof VerifyEmailRoute
  "/_app/account": typeof AppAccountRoute
  "/_app/autonomy": typeof AppAutonomyRoute
  "/_app/billing": typeof AppBillingRoute
  "/_app/brain": typeof AppBrainRoute
  "/_app/chat": typeof AppChatRoute
  "/_app/connectors": typeof AppConnectorsRoute
  "/_app/conversations": typeof AppConversationsRoute
  "/_app/knowledge": typeof AppKnowledgeRoute
  "/_app/media": typeof AppMediaRoute
  "/_app/memory": typeof AppMemoryRoute
  "/_app/projects": typeof AppProjectsRoute
  "/_app/prompts": typeof AppPromptsRoute
  "/_app/schedules": typeof AppSchedulesRoute
  "/_app/search": typeof AppSearchRoute
  "/_app/settings": typeof AppSettingsRoute
  "/_app/team": typeof AppTeamRoute
  "/_app/triggers": typeof AppTriggersRoute
  "/_app/usage": typeof AppUsageRoute
  "/_app/welcome": typeof AppWelcomeRoute
  "/share/album": typeof ShareAlbumRoute
  "/team/accept": typeof TeamAcceptRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/forgot"
    | "/login"
    | "/pricing"
    | "/privacy"
    | "/reset"
    | "/signup"
    | "/terms"
    | "/verify-email"
    | "/account"
    | "/autonomy"
    | "/billing"
    | "/brain"
    | "/chat"
    | "/connectors"
    | "/conversations"
    | "/knowledge"
    | "/media"
    | "/memory"
    | "/projects"
    | "/prompts"
    | "/schedules"
    | "/search"
    | "/settings"
    | "/team"
    | "/triggers"
    | "/usage"
    | "/welcome"
    | "/share/album"
    | "/team/accept"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/forgot"
    | "/login"
    | "/pricing"
    | "/privacy"
    | "/reset"
    | "/signup"
    | "/terms"
    | "/verify-email"
    | "/account"
    | "/autonomy"
    | "/billing"
    | "/brain"
    | "/chat"
    | "/connectors"
    | "/conversations"
    | "/knowledge"
    | "/media"
    | "/memory"
    | "/projects"
    | "/prompts"
    | "/schedules"
    | "/search"
    | "/settings"
    | "/team"
    | "/triggers"
    | "/usage"
    | "/welcome"
    | "/share/album"
    | "/team/accept"
  id:
    | "__root__"
    | "/"
    | "/_app"
    | "/forgot"
    | "/login"
    | "/pricing"
    | "/privacy"
    | "/reset"
    | "/signup"
    | "/terms"
    | "/verify-email"
    | "/_app/account"
    | "/_app/autonomy"
    | "/_app/billing"
    | "/_app/brain"
    | "/_app/chat"
    | "/_app/connectors"
    | "/_app/conversations"
    | "/_app/knowledge"
    | "/_app/media"
    | "/_app/memory"
    | "/_app/projects"
    | "/_app/prompts"
    | "/_app/schedules"
    | "/_app/search"
    | "/_app/settings"
    | "/_app/team"
    | "/_app/triggers"
    | "/_app/usage"
    | "/_app/welcome"
    | "/share/album"
    | "/team/accept"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ForgotRoute: typeof ForgotRoute
  LoginRoute: typeof LoginRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetRoute: typeof ResetRoute
  SignupRoute: typeof SignupRoute
  TermsRoute: typeof TermsRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  ShareAlbumRoute: typeof ShareAlbumRoute
  TeamAcceptRoute: typeof TeamAcceptRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/verify-email": {
      id: "/verify-email"
      path: "/verify-email"
      fullPath: "/verify-email"
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/terms": {
      id: "/terms"
      path: "/terms"
      fullPath: "/terms"
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/signup": {
      id: "/signup"
      path: "/signup"
      fullPath: "/signup"
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/reset": {
      id: "/reset"
      path: "/reset"
      fullPath: "/reset"
      preLoaderRoute: typeof ResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/privacy": {
      id: "/privacy"
      path: "/privacy"
      fullPath: "/privacy"
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/pricing": {
      id: "/pricing"
      path: "/pricing"
      fullPath: "/pricing"
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/forgot": {
      id: "/forgot"
      path: "/forgot"
      fullPath: "/forgot"
      preLoaderRoute: typeof ForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/team/accept": {
      id: "/team/accept"
      path: "/team/accept"
      fullPath: "/team/accept"
      preLoaderRoute: typeof TeamAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/share/album": {
      id: "/share/album"
      path: "/share/album"
      fullPath: "/share/album"
      preLoaderRoute: typeof ShareAlbumRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/welcome": {
      id: "/_app/welcome"
      path: "/welcome"
      fullPath: "/welcome"
      preLoaderRoute: typeof AppWelcomeRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/usage": {
      id: "/_app/usage"
      path: "/usage"
      fullPath: "/usage"
      preLoaderRoute: typeof AppUsageRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/triggers": {
      id: "/_app/triggers"
      path: "/triggers"
      fullPath: "/triggers"
      preLoaderRoute: typeof AppTriggersRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/team": {
      id: "/_app/team"
      path: "/team"
      fullPath: "/team"
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings": {
      id: "/_app/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/search": {
      id: "/_app/search"
      path: "/search"
      fullPath: "/search"
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/schedules": {
      id: "/_app/schedules"
      path: "/schedules"
      fullPath: "/schedules"
      preLoaderRoute: typeof AppSchedulesRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/prompts": {
      id: "/_app/prompts"
      path: "/prompts"
      fullPath: "/prompts"
      preLoaderRoute: typeof AppPromptsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/projects": {
      id: "/_app/projects"
      path: "/projects"
      fullPath: "/projects"
      preLoaderRoute: typeof AppProjectsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/memory": {
      id: "/_app/memory"
      path: "/memory"
      fullPath: "/memory"
      preLoaderRoute: typeof AppMemoryRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/media": {
      id: "/_app/media"
      path: "/media"
      fullPath: "/media"
      preLoaderRoute: typeof AppMediaRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/knowledge": {
      id: "/_app/knowledge"
      path: "/knowledge"
      fullPath: "/knowledge"
      preLoaderRoute: typeof AppKnowledgeRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/conversations": {
      id: "/_app/conversations"
      path: "/conversations"
      fullPath: "/conversations"
      preLoaderRoute: typeof AppConversationsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/connectors": {
      id: "/_app/connectors"
      path: "/connectors"
      fullPath: "/connectors"
      preLoaderRoute: typeof AppConnectorsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/chat": {
      id: "/_app/chat"
      path: "/chat"
      fullPath: "/chat"
      preLoaderRoute: typeof AppChatRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/brain": {
      id: "/_app/brain"
      path: "/brain"
      fullPath: "/brain"
      preLoaderRoute: typeof AppBrainRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/billing": {
      id: "/_app/billing"
      path: "/billing"
      fullPath: "/billing"
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/autonomy": {
      id: "/_app/autonomy"
      path: "/autonomy"
      fullPath: "/autonomy"
      preLoaderRoute: typeof AppAutonomyRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/account": {
      id: "/_app/account"
      path: "/account"
      fullPath: "/account"
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppAutonomyRoute: typeof AppAutonomyRoute
  AppBillingRoute: typeof AppBillingRoute
  AppBrainRoute: typeof AppBrainRoute
  AppChatRoute: typeof AppChatRoute
  AppConnectorsRoute: typeof AppConnectorsRoute
  AppConversationsRoute: typeof AppConversationsRoute
  AppKnowledgeRoute: typeof AppKnowledgeRoute
  AppMediaRoute: typeof AppMediaRoute
  AppMemoryRoute: typeof AppMemoryRoute
  AppProjectsRoute: typeof AppProjectsRoute
  AppPromptsRoute: typeof AppPromptsRoute
  AppSchedulesRoute: typeof AppSchedulesRoute
  AppSearchRoute: typeof AppSearchRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTeamRoute: typeof AppTeamRoute
  AppTriggersRoute: typeof AppTriggersRoute
  AppUsageRoute: typeof AppUsageRoute
  AppWelcomeRoute: typeof AppWelcomeRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppAutonomyRoute: AppAutonomyRoute,
  AppBillingRoute: AppBillingRoute,
  AppBrainRoute: AppBrainRoute,
  AppChatRoute: AppChatRoute,
  AppConnectorsRoute: AppConnectorsRoute,
  AppConversationsRoute: AppConversationsRoute,
  AppKnowledgeRoute: AppKnowledgeRoute,
  AppMediaRoute: AppMediaRoute,
  AppMemoryRoute: AppMemoryRoute,
  AppProjectsRoute: AppProjectsRoute,
  AppPromptsRoute: AppPromptsRoute,
  AppSchedulesRoute: AppSchedulesRoute,
  AppSearchRoute: AppSearchRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTeamRoute: AppTeamRoute,
  AppTriggersRoute: AppTriggersRoute,
  AppUsageRoute: AppUsageRoute,
  AppWelcomeRoute: AppWelcomeRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotRoute: ForgotRoute,
  LoginRoute: LoginRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  ResetRoute: ResetRoute,
  SignupRoute: SignupRoute,
  TermsRoute: TermsRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  ShareAlbumRoute: ShareAlbumRoute,
  TeamAcceptRoute: TeamAcceptRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
